import { setUser, setZoneUploaderList } from "../actions/user";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";

export const zoneEvent = (reqObj) => {
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.post(urls.zoneEvent, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getAllZoneUploadData = (pageNo, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getAllZoneUploadData, {
			params: {
				page: pageNo || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200 && response.data) {
				dispatch(setZoneUploaderList(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});
